/**
 * Routes Configuration
 * Central configuration for all routes in the application
 * Add new pages here to automatically register them
 */

import Home from '../Pages/Home';
import About from '../Pages/About';
import Donate from '../Pages/Donate';
import DonateCurrency from '../Pages/DonateCurrency';
import Reports from '../Pages/Reports';
import Contacts from '../Pages/Contacts';
import ReportDetail from '../Pages/ReportDetail';
import BusinessSupport from '../Pages/BusinessSupport';
import Programs from '../Pages/Programs';
import Partners from '../Pages/Partners';
import PartnerDetail from '../Pages/PartnerDetail';
import GdprPolicy from '../Pages/GdprPolicy';
import NotFound from '../Pages/NotFound';

/**
 * Client-side redirects for legacy capitalized URLs that Google has already crawled.
 * These mirror the server-side redirects in netlify.toml / .htaccess / vercel.json and
 * act as a fallback so React Router redirects them even before the server redirect fires.
 */
export const LEGACY_REDIRECTS = [
  { from: '/Home', to: '/' },
  { from: '/About', to: '/about' },
  { from: '/Contacts', to: '/contacts' },
  { from: '/Reports', to: '/reports' },
  { from: '/Donate', to: '/donate' },
  { from: '/Partners', to: '/partners' },
  { from: '/Business', to: '/business' },
  { from: '/Programs', to: '/programs' },
];

export const ROUTES = [
  {
    path: '/',
    element: Home,
    name: 'home',
    showInNav: true,
    order: 1,
  },
  {
    path: '/about',
    element: About,
    name: 'about',
    showInNav: true,
    order: 2,
  },
  {
    path: '/business',
    element: BusinessSupport,
    name: 'business',
    showInNav: true,
    order: 3,
  },
  {
    path: '/programs',
    element: Programs,
    name: 'programs',
    showInNav: true,
    order: 4,
  },
  {
    path: '/partners',
    element: Partners,
    name: 'partners',
    showInNav: true,
    order: 5,
  },
  {
    path: '/partners/:id',
    element: PartnerDetail,
    name: 'partnerDetail',
    showInNav: false,
  },
  {
    path: '/reports',
    element: Reports,
    name: 'reports',
    showInNav: true,
    order: 6,
  },
  {
    path: '/reports/:id',
    element: ReportDetail,
    name: 'reportDetail',
    showInNav: false,
  },
  {
    path: '/donate',
    element: Donate,
    name: 'donate',
    showInNav: true,
    order: 7,
  },
  {
    path: '/donate/currency',
    element: DonateCurrency,
    name: 'donateCurrency',
    showInNav: false,
  },
  {
    path: '/contacts',
    element: Contacts,
    name: 'contacts',
    showInNav: true,
    order: 8,
  },
  {
    path: '/gdpr-policy',
    element: GdprPolicy,
    name: 'gdprPolicy',
    showInNav: false,
  },
  {
    path: '*',
    element: NotFound,
    name: 'notfound',
    showInNav: false,
  },
];

/**
 * Get routes that should appear in navigation
 */
export const getNavigationRoutes = () => {
  return ROUTES.filter(route => route.showInNav).sort((a, b) =>
    (a.order || 999) - (b.order || 999)
  );
};

/**
 * Get route by path
 */
export const getRouteByPath = (path) => {
  return ROUTES.find(route => route.path === path);
};
